import {ProjectStagePhaseId} from "../../models/projects/ProjectStagePhase";
import {UserViewSettings, UserViewSettingsProp} from "../../models/common/ViewSettings";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {ProjectStagePhaseTaskEmployee} from "../../models/projects/ProjectStagePhaseTaskEmployee";
import {Identifier} from "../../models/common/Identifier";
import {Observable, of} from "rxjs";
import {ofType, StateObservable} from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {getUrlParamsFromViewSettings} from "../../config/RouteConfig";
import {ProjectId, ProjectStageIdPath, ProjectStagePhaseIdPath} from "../../models/projects/Project";
import {ajax} from "rxjs/ajax";
import {catchError, map, switchMap} from "rxjs/operators";
import {eventNotificationError} from "../common/EventNotificationActions";
import {ApiReturnType} from "../../models/common/ApiReturnType";
import {ProjectStageId} from "../../models/projects/ProjectStage";


export type ProjectStagePhaseEmployeeActionTypes = FetchProjectStagePhaseEmployeesActionTypes
    | FetchProjectStageEmployeesActionTypes
    | FetchProjectEmployeesActionTypes

/**
 * fetch phase employee
 *
 * every employee has to be added to a project to see the project and log workhours on it
 */
export interface FetchProjectStagePhaseEmployeesAction extends UserViewSettingsProp, ReduxAction< typeof FETCH_PROJECT_STAGE_PHASE_EMPLOYEES> {
    phaseIdPath: ProjectStagePhaseIdPath
}
export interface FetchProjectStagePhaseEmployeesSuccessAction  extends ProjectStagePhaseId, ReduxAction< typeof FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_SUCCESS> {
    payload: ApiReturnType< ProjectStagePhaseTaskEmployee[] >
}
export interface FetchProjectStagePhaseEmployeesErrorAction  extends ProjectStagePhaseId, ErrorAction< typeof FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_ERROR> {}

export type FetchProjectStagePhaseEmployeesActionTypes = FetchProjectStagePhaseEmployeesAction
    | FetchProjectStagePhaseEmployeesSuccessAction
    | FetchProjectStagePhaseEmployeesErrorAction

export const FETCH_PROJECT_STAGE_PHASE_EMPLOYEES = "FETCH_PROJECT_STAGE_PHASE_EMPLOYEES";
export const FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_SUCCESS = "FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_SUCCESS";
export const FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_ERROR = "FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_ERROR";

export function fetchProjectStagePhaseEmployees(
    phaseIdPath: ProjectStagePhaseIdPath,
    userViewSettings: UserViewSettings
): FetchProjectStagePhaseEmployeesAction {
    return { type: FETCH_PROJECT_STAGE_PHASE_EMPLOYEES,  phaseIdPath, userViewSettings };
}
export function fetchProjectStagePhaseEmployeesSuccess(
    phaseId: Identifier<number>,
    payload: ApiReturnType< ProjectStagePhaseTaskEmployee[] >
): FetchProjectStagePhaseEmployeesSuccessAction {
    return { type: FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_SUCCESS, phaseId, payload };
}
export function fetchProjectStagePhaseEmployeesError( phaseId: Identifier<number>, error: any ): FetchProjectStagePhaseEmployeesErrorAction {
    return { type: FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_ERROR, phaseId, error };
}

export function fetchProjectStagePhaseEmployeesEpic(
    action$: Observable< FetchProjectStagePhaseEmployeesAction >,
    store$: StateObservable<AppState>
) {


    return action$.pipe(
        ofType( FETCH_PROJECT_STAGE_PHASE_EMPLOYEES ),
        switchMap( action => {
            const path = `${APP_CONFIG.baseWeb}projects/${action.phaseIdPath.projectId.rawValue }/stages/${action.phaseIdPath.projectStageId.rawValue}/phases/${ action.phaseIdPath.phaseId.rawValue }/employees/${ getUrlParamsFromViewSettings( action.userViewSettings )}`;

            return ajax( APP_CONFIG.getRequestObject( path ) ).pipe(
                map( response => fetchProjectStagePhaseEmployeesSuccess(
                    action.phaseIdPath.phaseId,
                    response.response as ApiReturnType< ProjectStagePhaseTaskEmployee[] >
                ) ),
                catchError( error => of(
                    fetchProjectStagePhaseEmployeesError( action.phaseIdPath.phaseId, error ),
                    eventNotificationError( error, store$, 'phase_employee', 'fetchProjectStagePhaseEmployees' )
                ) )
            );
        } )
    );

}

/**
 * fetch stages employee
 *
 * every employee has to be added to a project to see the project and log workhours on it
 */
export interface FetchProjectStageEmployeesAction extends UserViewSettingsProp, ReduxAction< typeof FETCH_PROJECT_STAGE_EMPLOYEES> {
    stageIdPath: ProjectStageIdPath
}
export interface FetchProjectStageEmployeesSuccessAction  extends ProjectStageId, ReduxAction< typeof FETCH_PROJECT_STAGE_EMPLOYEES_SUCCESS> {
    payload: ApiReturnType< ProjectStagePhaseTaskEmployee[] >
}
export interface FetchProjectStageEmployeesErrorAction  extends ProjectStageId, ErrorAction< typeof FETCH_PROJECT_STAGE_EMPLOYEES_ERROR> {}

export type FetchProjectStageEmployeesActionTypes = FetchProjectStageEmployeesAction
    | FetchProjectStageEmployeesSuccessAction
    | FetchProjectStageEmployeesErrorAction

export const FETCH_PROJECT_STAGE_EMPLOYEES = "FETCH_PROJECT_STAGE_EMPLOYEES";
export const FETCH_PROJECT_STAGE_EMPLOYEES_SUCCESS = "FETCH_PROJECT_STAGE_EMPLOYEES_SUCCESS";
export const FETCH_PROJECT_STAGE_EMPLOYEES_ERROR = "FETCH_PROJECT_STAGE_EMPLOYEES_ERROR";

export function fetchProjectStageEmployees(
    stageIdPath: ProjectStageIdPath,
    userViewSettings: UserViewSettings
): FetchProjectStageEmployeesAction {
    return { type: FETCH_PROJECT_STAGE_EMPLOYEES,  stageIdPath, userViewSettings };
}
export function fetchProjectStageEmployeesSuccess(
    stageId: Identifier<number>,
    payload: ApiReturnType< ProjectStagePhaseTaskEmployee[] >
): FetchProjectStageEmployeesSuccessAction {
    return { type: FETCH_PROJECT_STAGE_EMPLOYEES_SUCCESS, projectStageId: stageId, payload };
}
export function fetchProjectStageEmployeesError( stageId: Identifier<number>, error: any ): FetchProjectStageEmployeesErrorAction {
    return { type: FETCH_PROJECT_STAGE_EMPLOYEES_ERROR, projectStageId: stageId, error };
}

export function fetchProjectStageEmployeesEpic(
    action$: Observable< FetchProjectStageEmployeesAction >,
    store$: StateObservable<AppState>
) {


    return action$.pipe(
        ofType( FETCH_PROJECT_STAGE_EMPLOYEES ),
        switchMap( action => {
            const path = `${APP_CONFIG.baseWeb}projects/${action.stageIdPath.projectId.rawValue }/stages/${action.stageIdPath.projectStageId.rawValue}/employees/${ getUrlParamsFromViewSettings( action.userViewSettings )}`;

            return ajax( APP_CONFIG.getRequestObject( path ) ).pipe(
                map( response => fetchProjectStageEmployeesSuccess(
                    action.stageIdPath.projectStageId,
                    response.response as ApiReturnType< ProjectStagePhaseTaskEmployee[] >
                ) ),
                catchError( error => of(
                    fetchProjectStageEmployeesError( action.stageIdPath.projectStageId, error ),
                    eventNotificationError( error, store$, 'stage_employee', 'fetchProjectStageEmployees' )
                ) )
            );
        } )
    );

}

/**
 * fetch project employee
 *
 * every employee has to be added to a project to see the project and log workhours on it
 */
export interface FetchProjectEmployeesAction extends ProjectId, UserViewSettingsProp, ReduxAction< typeof FETCH_PROJECT_EMPLOYEES> {}
export interface FetchProjectEmployeesSuccessAction  extends ProjectId, ReduxAction< typeof FETCH_PROJECT_EMPLOYEES_SUCCESS> {
    payload: ApiReturnType< ProjectStagePhaseTaskEmployee[] >
}
export interface FetchProjectEmployeesErrorAction  extends ProjectId, ErrorAction< typeof FETCH_PROJECT_EMPLOYEES_ERROR> {}

export type FetchProjectEmployeesActionTypes = FetchProjectEmployeesAction
    | FetchProjectEmployeesSuccessAction
    | FetchProjectEmployeesErrorAction

export const FETCH_PROJECT_EMPLOYEES = "FETCH_PROJECT_EMPLOYEES";
export const FETCH_PROJECT_EMPLOYEES_SUCCESS = "FETCH_PROJECT_EMPLOYEES_SUCCESS";
export const FETCH_PROJECT_EMPLOYEES_ERROR = "FETCH_PROJECT_EMPLOYEES_ERROR";

export function fetchProjectEmployees(
    projectId: Identifier<number>,
    userViewSettings: UserViewSettings
): FetchProjectEmployeesAction {
    return { type: FETCH_PROJECT_EMPLOYEES, projectId, userViewSettings};
}

export function fetchProjectEmployeesSuccess(
    projectId: Identifier<number>,
    payload: ApiReturnType< ProjectStagePhaseTaskEmployee[] >
): FetchProjectEmployeesSuccessAction {
    return { type: FETCH_PROJECT_EMPLOYEES_SUCCESS, projectId, payload };
}
export function fetchProjectEmployeesError( projectId: Identifier<number>, error: any ): FetchProjectEmployeesErrorAction {
    return { type: FETCH_PROJECT_EMPLOYEES_ERROR, projectId, error };
}

export function fetchProjectEmployeesEpic(
    action$: Observable< FetchProjectEmployeesAction >,
    store$: StateObservable<AppState>
) {


    return action$.pipe(
        ofType( FETCH_PROJECT_EMPLOYEES ),
        switchMap( action => {
            const path = `${APP_CONFIG.baseWeb}projects/${action.projectId.rawValue }/employees/${ getUrlParamsFromViewSettings( action.userViewSettings )}`;

            return ajax( APP_CONFIG.getRequestObject( path ) ).pipe(
                map( response => fetchProjectEmployeesSuccess(
                    action.projectId,
                    response.response as ApiReturnType< ProjectStagePhaseTaskEmployee[] >
                ) ),
                catchError( error => of(
                    fetchProjectEmployeesError( action.projectId, error ),
                    eventNotificationError( error, store$, 'project_employee', 'fetchProjectEmployees' )
                ) )
            );
        } )
    );

}